// extracted by mini-css-extract-plugin
module.exports = {"errorLogs":"EditorFilesMobileFooter_errorLogs__3vCmo"};